import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initAppearance } from './lib/appearance';
import { queryClient } from './lib/queryClient';
import { initTheme } from './lib/theme';
import { router } from './router';
import './styles.css';

initTheme();
initAppearance();

// After a deploy the previous build's chunks are gone from the server, so a page
// that has been open since (a background tab, the desktop app) fails to load the
// next screen. Reload once to pick up the new build; the guard stops a loop if
// the chunk is missing for another reason. Offline, a reload would only swap the
// app for the browser's error page, so the failure is left to the app as before.
window.addEventListener('vite:preloadError', (event) => {
  if (!navigator.onLine) return;
  const KEY = 'deeds.chunkReloadAt';
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // no sessionStorage: reload anyway
  }
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
